<ng-container *transloco="let t">
  <app-strategy-overlay>
    <div class="flex h-full flex-col gap-4">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-2">
          <IToggle
            [checked]="enabled"
            (checkedChange)="toggleActivate(!!$event)"
            size="lg"
            [disabled]="isReadOnly || !strategies || strategies.length === 0"
          />
          <div class="text-lg font-medium tracking-tight text-gray-800">
            {{ t("strategy-boost.activate_promo_days") }}
          </div>
        </div>

        @if (enabled && strategies && strategies.length > 0) {
          <div class="flex items-center gap-2">
            <IDatePicker
              [minDate]="minDate"
              [maxDate]="maxDate"
              [disabled]="!enabled || isReadOnly"
              [dateFormat]="dateFormat()"
              [withShortcuts]="false"
              [selectedDateRange]="dateRange()"
              (selectedDateRangeChange)="update($event)"
            />
            <IButton
              [disabled]="isReadOnly"
              tooltipValue="{{ t('strategy-boost.upload_promo_days_settings') }}"
              [icon]="ICON_IMPORT"
              (onClick)="uploadPromoDays()"
              color="white"
              label="{{ t('common.import') }}"
            />
            <app-export-button
              (export)="exportAsCsv()"
              tooltipValue="{{ t('strategy-boost.export_promo_days_settings_as_csv') }}"
            />
          </div>
        }
      </div>

      @if (enabled && strategies && strategies.length > 0) {
        <grid-layout class="flex-1">
          <app-strategy-boost-grid
            class="h-full w-full"
            [data]="strategies"
            [accountMarketplace]="accountMarketplace!"
            [dateRange]="dateRange()"
            [isReadOnly]="isReadOnly"
          />
        </grid-layout>
      }
      @if (!strategies || strategies.length === 0) {
        <IAlert type="warning" [title]="t('strategy-boost.no_live_strategies_on_this_marketplace')" />
      }
    </div>
  </app-strategy-overlay>
</ng-container>
